import "../../../../content/projects/bspb-special/bspb-special.css";
import * as React from 'react';
export default {
  React
};